import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';

class DeleteAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zgoda: false,
      user: this.props.userData,
      result: null,
      showMsg: false,
    };
  }

  changeInput = e => {
    const value = e.target.checked;

    this.setState({
      zgoda: !this.state.zgoda,
    });
  };

  deleteUser = () => {
    const data = {
      id: this.state.user.ID,
      email: this.state.user.Email,
      login: this.state.user.username,
    };
    const url = `${process.env.API_URL}/users/sendConfirm`;
    // let url = `http://localhost:8000/api/v1.0/users/sendConfirm`;

    fetch(url, {
      method: 'POST',
      contentType: 'application/json',
      body: JSON.stringify(data),
    })
      .then(r => r.json())
      .then(resp => {
        this.setState({ result: resp, showMsg: true });
      });
  };

  showMsg = () => {
    if (this.state.showMsg) {
      return this.state.result.msg;
    }
  };

  render() {
    return (
      <div>
        <div className={s.delContainer} style={{ display: 'block' }}>
          <div className={s.delTitle}>Usuwanie konta</div>
          <GrayPanel title="Informacja">
            <input hidden name="userID" value={this.state.user.ID} />
            Aby usunąć konto zaznacz opcję
            <ul>
              <li>Chcę usunąć konto</li>
            </ul>
            Następnie naciścnij przycisk <b>Usuń konto</b>
          </GrayPanel>

          <GrayPanel title="Usuwanie konta">
            <div className="row">
              <input
                type="checkbox"
                className="form-check-input"
                id="check"
                onChange={this.changeInput}
              />{' '}
              Chcę usunąć konto
            </div>
            <br />
            <div className="row">
              <button
                className="btn btn-danger"
                onClick={this.deleteUser}
                disabled={!this.state.zgoda}
              >
                Usuń konto
              </button>
            </div>
            <br />
            {this.state.result ? <div className="alert alert-danger">{this.showMsg()}</div> : null}
          </GrayPanel>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(DeleteAccount);



// WEBPACK FOOTER //
// src/routes/DeleteAccount/index.js